/*
 * © 2026 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
export const POPUP_GROUP_JOB_SUMMARY = "job-summary-popup";
export const JOB_SUMMARY_POPUP_ID_PREFIX = "jsp_";
export const getPopupId = (job: { id: string } | undefined) =>
  `${JOB_SUMMARY_POPUP_ID_PREFIX}${job?.id}`;
